import { DocumentsTableComponent } from '@app/features/documents/components/documents-table/documents-table.component';
import { NgModule } from '@angular/core';
import { DocumentsRoutingModule } from '@app/features/documents/documents-routing.module';
import { DocumentsComponent } from '@app/features/documents/documents.component';
import { DocumentsPageComponent } from '@app/features/documents/pages/documents-page.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';

const components = [
  DocumentsComponent,
  DocumentsPageComponent,
  DocumentsTableComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule, DocumentsRoutingModule],
  declarations: [...components],
})
export class DocumentsModule {}
